import { BrandState } from 'modules/User';

/**
 * Get color palettes from the brand state object.
 *
 * @param brand The BrandState object that we want to get the color palettes.
 * @returns Two dimensional array of color string.
 */
export const getBrandColorPalette = (brand: BrandState) => {
  if (!brand.colors) {
    return [];
  }

  return brand.colors.map((item) => item.map((childItem) => childItem.color));
};
